import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AI_gif1 from "../../assets/Recruitment/AI_1.gif";
import AI_3 from "../../assets/Recruitment/AI_3.png";
import AI_gif5 from "../../assets/Recruitment/A1_5.gif";
import AI_4 from "../../assets/Recruitment/AI_4.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AiAccordion from "./Ai/Ai";
import MgmtAccordion from "./Mgmt/mgmt";
import SnaAccordion from "./Sna/sna";
import MechAccordion from "./Mech/mech";


export default function SimpleAccordion() {
  return (
    <div
      className="challenges"
      style={{ backgroundColor: "#071013", color: "white" }}
    >
      <div className="challenge-intro">
        <h1 className="black" style={{ color: "#f49221"}}>
          Recruitment <span className="orange">Challenges</span>
        </h1>
        
        <p className="black" style={{ color: "#ffffff" }}>
          Project MANAS brings you the opportunity to fast-track into the
          TaskPhase by competing in the Recruitment Challenges.
          <br />
          <b>
            MIT Students only from first year are eligible to apply for the same
          </b>
          .
          <br />
          <br />
          Eligible students can attempt the questions belonging to any division
          without requiring any pre-requisites.
          <br />
          <br />
          You are <b>recommended to apply for the interviews</b>, over{" "}
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://docs.google.com/forms/d/e/1FAIpQLSeNcbiQ5Od7yBgPGxPezvKWrOgYWL69-whGDMGfe9Zb8F99mQ/viewform"
          >
            here
          </a>
          , regardless of your submission of the Recruitment Challenge.
        </p>
        <p className="black" style={{ color: "#ffffff" }}>
          The deadline for the Recruitment Challenges of all divisions is{" "}
          <h3 style={{ color: "white" }}>
           <b>30th August 2025 at 11:59 PM.</b>
          </h3>
        </p>
        <p className="black" style={{ color: "#ffffff" }}>
          <h3 style={{ color: "white" }}>
            <b>Partial submissions are also encouraged.</b>
          </h3>
        </p>
        <p className="black" style={{ color: "#ffffff" }}>
          Recruitment Challenges is one of the ways to get into the Taskphase. Alternatively, you can choose to apply directly for the interviews.
          
        </p>
      </div>
      <div>
        <AiAccordion />
        <SnaAccordion />
        <MechAccordion />
        <MgmtAccordion />
        

 
      </div>
    </div>
  );
}
